import styles from '../invictusLanding.module.css'
import Elitefaculty from "../../../assets/faculty_icon1.svg";
import JEETraining from "../../../assets/training_icon2.svg";
import Mentorship from "../../../assets/mentorship_icon3.svg";
import Performance from "../../../assets/performance_icon4.svg";
import TestStructure from "../../../assets/test_icon5.svg";
import backImg from '../../../assets/whychoose_pattern.svg'
import { useEffect, useState } from 'react';

const cardData = [
    {
        title: "Elite Faculty",
        description:
            "Learn from the best mentors with 20+ years of experience and a history of producing IIT toppers.",
        image: Elitefaculty,
        gradient: "linear-gradient(to right, #133162, #3779B8)",
    },
    {
        title: "Focused JEE Advanced Training",
        description:
            "Tailor-made curriculum, study material, and strategies exclusively for JEE Advanced.",
        image: JEETraining,
        gradient: "linear-gradient(139deg, #454381 -5.32%, #A971B8 103.12%)",
    },
    {
        title: "Personalized Mentorship",
        description:
            "1:1 guidance, daily monitoring, and on-demand doubt resolution for individual attention.",
        image: Mentorship,
        gradient: "linear-gradient(139deg, #368885 -5.32%, #72B970 103.12%)",
    },
    {
        title: "Smart Performance Analytics",
        description:
            "Identify weak areas and improve faster with real-time tracking and error analysis.",
        image: Performance,
        gradient: "linear-gradient(139deg, #94454D -5.32%, #C29DA1 103.12%)",
    },
    {
        title: "Rigorous Test Structure",
        description:
            "Weekly and phase-wise JEE-level mock tests ensure consistent progress and exam readiness",
        image: TestStructure,
        gradient: "linear-gradient(139deg, #80743C -5.32%, #BAA851 103.12%)",
    },
];

const Card = ({ img, description, title, gradient }) => (
    <div
        className={styles.WhyIat_card}
        style={{ background: gradient }}
    >
        <div className={styles.WhyIat_card_content}>
            <img src={backImg} alt="backimg" className={styles.WhyIat_card_backImg} />
            <h6>{title}</h6>
            <p>
                {description}
            </p>
            <img className={styles.cardImg} src={img} alt={title} />

        </div>
    </div>
)

const WhyIat = () => {

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={`${styles.WhyIat_container}`}>
            <div className={styles.WhyIat_header_wrapper}>
                <div className={styles.WhyIat_header}>
                    <h1>Why <span>INVICTUS?</span></h1>
                    <p>
                        Advanced JEE program for IITs, led by the most experienced faculty
                    </p>
                </div>
            </div>
            <div className={`${styles.WhyIat_card_wrapper} container`}>
                {
                    cardData.map(({ title, description, image, gradient }, index) => (
                        <div
                            style={{ zIndex: index + 2, left: isMobile ? '' : `${(index) * 18}%`, paddingTop: `${(index + 1) * 90}vh` }}
                            className={styles.WhyIat_percard_wrapper}
                        >
                            <div style={{ position: 'sticky', top: isMobile ? index === 0 ? '10rem' : `${(index + 1) * 7}rem` : `${index % 2 === 0 ? "9rem" : '22rem'}` }}>
                                <Card description={description} img={image} title={title} gradient={gradient} />
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default WhyIat